import {
  SET_LIST_SUB_CATEGORY_DATA,
  SET_LIST_SUB_CATEGORY_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listSubCategoryData: null,
  listSubCategoryDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_SUB_CATEGORY_DATA:
      return {
        ...state,
        loading: false,
        listSubCategoryData: action.listSubCategoryData,
      };

    case SET_LIST_SUB_CATEGORY_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listSubCategoryDataTotal: action.listSubCategoryDataTotal,
      };

    default:
      return { ...state };
  }
};
